function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoPurchaseTemplate = require('./buysaito-purchase.template');
var SaitoPurchaseCompleteTemplate = require('./buysaito-complete.template');
var SaitoPurchaseLoaderTemplate = require('./buysaito-loader.template');
var SaitoPurchaseErrorTemplate = require('./buysaito-error.template');
var SaitoPurchaseCryptoTemplate = require('./buysaito-select-crypto.template');
var SaitoPurchaseAmountTemplate = require('./buysaito-amount.template');
var SaitoPurchaseFaucetAuthTemplate = require('./buysaito-faucet-auth.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoPurchaseOverlay = /*#__PURE__*/function () {
  function SaitoPurchaseOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, SaitoPurchaseOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true);
    this.session = 0;

    //
    // init
    //
    this.amount = 0;
    this.expected_deposit = 0;
    this.amount_input_source = 'crypto';
    this.crypto_selected = false;
    this.tx = null;
    this.recipient = '';
    this.description = '';
    this.payment_detected = false;
    this.internal_payment_pending = false;
    this.internal_payment_sending = false;
    this.reservation = null;
    this.saito_issuance = null;
    this.saito_receipts = new Map();
    this.reserved_until = 0;
    this.fancy_ui = true;
    this.active = false;
    this.acquisition_stage = 'default';
    this.acquisition_options = [];
    this.stage1_html = null;
    this.stage1_footer_html = null;
    this.faucet_already_issued = null;
    this.reservation_timer = null;
    this.payment_instruction_timer = null;
    this.saito_arrival_timer = null;
    this.saito_arrival_baseline = null;
    this.saito_arrival_expected = null;
    this.ui_msg = '';

    /**
     * Events (in reverse order):
     * 4. Confirm saito issued/TX sent
     * 3. Confirm Pending Depost
     * 2. Get deposit address
     * 1. Launch overlay
     */

    app.connection.on('saito-purchase-saito-issued', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.updateSaitoIssued(data);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('on-payment-received', function (data) {
      _this.receiveSaitoPayment(data);
    });
    app.connection.on('saito-purchase-payment-detected', function (data) {
      _this.receivePaymentDetected(data);
    });
    app.connection.on('saito-purchase-address-reserved', function (data) {
      _this.receivePaymentAddressFromServer(data);
    });
    app.connection.on('saito-purchase-error-notification', function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!_this.active) return;
      if ((data === null || data === void 0 ? void 0 : data.code) === 'insufficient_funds') {
        if (!_this.reservation || data.id !== _this.reservation.id || data.ticker !== _this.reservation.ticker || data.address !== _this.reservation.address) return;
        _this.clearPaymentInstructionTimer();
        _this.clearReservationTimer();
        // Keep the purchase session so a later payout can complete this overlay.
        _this.showOverlay(SaitoPurchaseErrorTemplate('', data.code));
        return;
      }
      // An unclassified issuance error is not evidence that a refill is needed.
      if (!(data !== null && data !== void 0 && data.message)) return;
      _this.clearPaymentInstructionTimer();
      _this.clearReservationTimer();
      _this.stopSaitoArrivalWatch();
      _this.reservation = null;
      _this.overlay.close();
      _this.showOverlay(SaitoPurchaseErrorTemplate(data === null || data === void 0 ? void 0 : data.message));
    });
    app.connection.on('saito-purchase-launch', function (amount) {
      var _this$mod$available_c;
      var recipient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      _this.reset();
      _this.active = true;
      _this.app.connection.emit('saito-purchase-overlay-open', function () {
        _this.close();
      });
      _this.amount = Number(amount);
      _this.description = description;
      _this.recipient = recipient || _this.mod.publicKey;
      _this.tx = tx;
      if (((_this$mod$available_c = _this.mod.available_currencies) === null || _this$mod$available_c === void 0 ? void 0 : _this$mod$available_c.length) == 0) {
        var _this$mod$buysaito_pe;
        if (!((_this$mod$buysaito_pe = _this.mod.buysaito_peer) !== null && _this$mod$buysaito_pe !== void 0 && _this$mod$buysaito_pe.publicKey)) {
          _this.mod.available_currencies = null;
          _this.render();
          return;
        }
        _this.showOverlay(SaitoPurchaseLoaderTemplate('Checking availability...'));
        _this.app.network.sendRequestAsTransaction('buysaito available currencies', null, function (response) {
          return _this.mod.receiveAvailableCurrencies(response);
        }, _this.mod.buysaito_peer.publicKey);
        _this.timer = setTimeout(function () {
          if (!_this.active) {
            return;
          }
          _this.mod.available_currencies = null;
          _this.render();
        }, 5000);
        return;
      }
      if (!amount) {
        _this.fancy_ui = false;
      }
      if (_this.fancy_ui) {
        // More complicated but smoother transition while fetching info
        _this.showOverlay(SaitoPurchaseLoaderTemplate('Checking availability...'));
        _this.timer = setTimeout(function () {
          if (!_this.active) {
            return;
          }
          _this.render();
        }, 1000);
        _this.fancy_ui = false;
      } else {
        _this.render();
      }
    });
    app.connection.on('saito-purchase-cryptos', function () {
      if (!_this.active || _this.crypto_selected) {
        return;
      }
      console.log('saito-purchase-cryptos', _this.mod.available_currencies);
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function () {
        if (!_this.active) {
          return;
        }
        _this.fancy_ui = false;
        _this.render();
      }, 1000);
    });
  }
  return _createClass(SaitoPurchaseOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var self, resumeStage, resumeOpt;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              self = this;
              resumeStage = this.acquisition_stage && this.acquisition_stage !== 'default' ? this.acquisition_stage : '';
              console.debug('SaitoPurchaseOverlay Rendering...', this.amount, this.description, this.crypto_selected, this.tx);
              if (this.mod.available_currencies) {
                _context2.n = 1;
                break;
              }
              this.overlay.remove();
              salert('Service currently not available');
              return _context2.a(2);
            case 1:
              // Reuse this overlay's layer while advancing the purchase flow. Recreating
              // it would move Get Saito above optional overlays opened in response to it.

              if (!this.crypto_selected) {
                //
                // 1. user selects crypto
                //
                this.showOverlay(SaitoPurchaseCryptoTemplate(this.app, this.mod, this));
              } else {
                if (!this.address) {
                  // 1.5 alternate amount selection
                  if (!this.amount) {
                    this.showOverlay(SaitoPurchaseAmountTemplate(this.app, this.mod, this));
                  } else {
                    //
                    // 2. show loading screen after selecting crypto ticker
                    //
                    this.showOverlay(SaitoPurchaseLoaderTemplate(this.ui_msg, ''));
                  }
                } else {
                  //
                  // 3. Show address screen when deposit address is created/fetched
                  //
                  if (!this.payment_detected && !this.internal_payment_sending) {
                    this.showOverlay(SaitoPurchaseTemplate(this.app, this.mod, this));
                    this.overlay.blockClose();
                    this.app.browser.generateQRCode(this.address, 'pqrcode');
                  } else {
                    //
                    // 4. Wait for detection of an internal transfer or issuance of SAITO.
                    //
                    this.showOverlay(SaitoPurchaseLoaderTemplate(this.ui_msg));
                    this.overlay.blockClose();
                  }
                }
              }

              // Populate optional acquisition entries from current module state whenever
              // the Stage 1 shell is built. Availability may have arrived before the
              // overlay existed.
              if (!this.crypto_selected) {
                this.renderAcquisitionOptions();
              }
              this.attachEvents();

              // Resume faucet-auth (etc.) after Stage 1 shell was rebuilt.
              if (resumeStage && document.getElementById('buysaito-stage')) {
                resumeOpt = this.acquisition_options.find(function (opt) {
                  return opt.inline_stage === resumeStage;
                }) || null;
                this.enterAcquisitionStage(resumeStage, resumeOpt);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /**
     * Collect optional acquisition entries from other modules
     * (e.g. Faucet via respondTo('buysaito-options')) and render them
     * into `.buysaito-options` above purchase methods / fallback info.
     *
     * Options may declare `inline_stage` to transition this overlay's
     * lower `#buysaito-stage` in place instead of opening another overlay.
     */
  }, {
    key: "renderAcquisitionOptions",
    value: function renderAcquisitionOptions() {
      var _this2 = this;
      var container = document.querySelector('#purchase-container .buysaito-options');
      if (!container) {
        return;
      }
      var options = (this.app.modules.getRespondTos('buysaito-options') || []).filter(function (opt) {
        return opt && (opt.title || opt.text) && (typeof opt.callback === 'function' || opt.inline_stage);
      }).sort(function (a, b) {
        return (a.rank || 0) - (b.rank || 0);
      });
      this.acquisition_options = options;
      if (!options.length) {
        container.innerHTML = '';
        this.updatePurchaseMethodHeading(false);
        return;
      }
      if (this.faucet_already_issued) {
        var dailyLimit = this.faucet_already_issued.daily_limit === true;
        var noticeTitle = dailyLimit ? 'Daily faucet allocation already received' : 'Faucet allocation already received';
        var noticeDescription = dailyLimit ? 'This Saito public key has used the network faucet in the last 24 hours. You can request another allocation after the cooldown, continue with the purchase options below, or return to your previous action.' : 'This Saito public key has already received its one-time SAITO allocation from the network faucet. You can continue with purchase options below, or close this window and return to your previous action.';
        container.innerHTML = "\n      <div class=\"buysaito-option buysaito-option-faucet-issued\" role=\"status\">\n        <div class=\"buysaito-option-icon\">\n          <i class=\"fa-solid fa-circle-info\" aria-hidden=\"true\"></i>\n        </div>\n        <div class=\"buysaito-option-copy\">\n          <div class=\"buysaito-option-title\">".concat(noticeTitle, "</div>\n          <div class=\"buysaito-option-description\">\n            ").concat(noticeDescription, "\n          </div>\n        </div>\n      </div>\n    ");
        // Issued notice replaces the green Faucet card — use the default payment heading.
        this.updatePurchaseMethodHeading(false);
        return;
      }
      container.innerHTML = options.map(function (opt, index) {
        var title = opt.title || opt.text || '';
        var description = opt.description || '';
        var icon = opt.icon || '';
        var iconHtml = icon ? "<i class=\"".concat(icon, "\" aria-hidden=\"true\"></i>") : '';
        var optionClass = ['buysaito-option', opt.option_class || '', opt.id === 'faucet' ? 'buysaito-option-faucet' : ''].filter(Boolean).join(' ');
        var optionId = opt.id ? " data-buysaito-option-id=\"".concat(opt.id, "\"") : '';
        return "\n            <button type=\"button\" class=\"".concat(optionClass, "\" data-buysaito-option=\"").concat(index, "\"").concat(optionId, ">\n              <div class=\"buysaito-option-icon\">").concat(iconHtml, "</div>\n              <div class=\"buysaito-option-copy\">\n                <div class=\"buysaito-option-title\">").concat(title, "</div>\n                ").concat(description ? "<div class=\"buysaito-option-description\">".concat(description, "</div>") : '', "\n              </div>\n            </button>\n          ");
      }).join('');
      var showFaucetOption = options.some(function (opt) {
        return opt.id === 'faucet';
      });
      this.updatePurchaseMethodHeading(showFaucetOption);
      container.querySelectorAll('[data-buysaito-option]').forEach(function (el) {
        el.onclick = function (e) {
          var _this2$acquisition_op;
          e.preventDefault();
          var index = parseInt(el.getAttribute('data-buysaito-option'), 10);
          var opt = (_this2$acquisition_op = _this2.acquisition_options) === null || _this2$acquisition_op === void 0 ? void 0 : _this2$acquisition_op[index];
          if (!opt) {
            return;
          }

          // Prefer in-overlay stage transition (Faucet auth, future claim states).
          if (opt.inline_stage) {
            _this2.enterAcquisitionStage(opt.inline_stage, opt);
            return;
          }
          if (typeof opt.callback === 'function') {
            opt.callback(_this2.app, _this2.mod, _this2);
          }
        };
      });
    }

    /**
     * Stage 1 crypto-list heading: default "CHOOSE PAYMENT METHOD", or
     * "OR PURCHASE DIRECTLY" when the green Faucet option card is present.
     */
  }, {
    key: "updatePurchaseMethodHeading",
    value: function updatePurchaseMethodHeading() {
      var showFaucetOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var purchaseContainer = document.getElementById('purchase-container');
      var msg = document.querySelector('#buysaito-stage .purchase-select-crypto-msg');
      purchaseContainer === null || purchaseContainer === void 0 || purchaseContainer.classList.toggle('has-faucet-option', !!showFaucetOption);
      if (msg) {
        msg.textContent = showFaucetOption ? 'OR PURCHASE DIRECTLY' : 'CHOOSE PAYMENT METHOD';
      }
    }

    /**
     * Replace the green Faucet intro card with a neutral/orange notice that the
     * public key is not currently eligible for another faucet allocation.
     * Keeps Get SAITO open; does not open the Faucet claim overlay.
     */
  }, {
    key: "showFaucetAlreadyIssuedNotice",
    value: function showFaucetAlreadyIssuedNotice() {
      var _document$getElementB;
      var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.faucet_already_issued = details && _typeof(details) === 'object' ? details : {};

      // Restore Stage 1 purchase/fallback content under the notice.
      if (this.acquisition_stage !== 'default' && this.stage1_html != null) {
        var stageEl = document.getElementById('buysaito-stage');
        if (stageEl) {
          stageEl.innerHTML = this.stage1_html;
        }
        this.acquisition_stage = 'default';
        this.stage1_html = null;
      }
      var footer = document.querySelector('#purchase-container .buysaito-footer-note');
      if (footer && this.stage1_footer_html != null) {
        footer.classList.remove('buysaito-footer-nav');
        footer.innerHTML = this.stage1_footer_html;
        this.stage1_footer_html = null;
      }
      (_document$getElementB = document.getElementById('purchase-container')) === null || _document$getElementB === void 0 || _document$getElementB.classList.remove('buysaito-stage-faucet-auth');
      this.attachEvents();
    }

    /**
     * True when the Get SAITO purchase overlay is currently visible.
     */
  }, {
    key: "isPurchaseOverlayOpen",
    value: function isPurchaseOverlayOpen() {
      return !!(this.active && this.overlay && document.querySelector('#purchase-container'));
    }

    /**
     * Replace only `#buysaito-stage` content. Keeps the GET SAITO shell,
     * options strip (Faucet card), separator, and overlay geometry intact.
     */
  }, {
    key: "enterAcquisitionStage",
    value: function enterAcquisitionStage() {
      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var stageEl = document.getElementById('buysaito-stage');
      if (!stageEl || !stage) {
        return;
      }
      if (this.acquisition_stage === 'default') {
        this.stage1_html = stageEl.innerHTML;
      }
      this.acquisition_stage = stage;
      if (stage === 'faucet-auth') {
        var _document$getElementB2;
        var providers = Array.isArray(opt === null || opt === void 0 ? void 0 : opt.providers) && opt.providers.length ? opt.providers : this.defaultFaucetAuthProviders();
        stageEl.innerHTML = SaitoPurchaseFaucetAuthTemplate(providers, opt === null || opt === void 0 ? void 0 : opt.auth_message);
        (_document$getElementB2 = document.getElementById('purchase-container')) === null || _document$getElementB2 === void 0 || _document$getElementB2.classList.add('buysaito-stage-faucet-auth');

        // Host back-nav in the same footer slot as the migration note (main-screen height/rhythm).
        var footer = document.querySelector('#purchase-container .buysaito-footer-note');
        if (footer) {
          this.stage1_footer_html = footer.innerHTML;
          footer.classList.add('buysaito-footer-nav');
          footer.innerHTML = "\n          <button type=\"button\" class=\"saito-button-square\" data-buysaito-stage-back aria-label=\"Return to purchase options\">\n            <i class=\"fa-solid fa-arrow-left\" aria-hidden=\"true\"></i>\n          </button>\n          <button type=\"button\" class=\"buysaito-stage-nav-label\" data-buysaito-stage-back>\n            Return to purchase options\n          </button>\n        ";
        }
        this.attachFaucetAuthStageEvents(opt);
        return;
      }
      console.warn('BuySaito: unknown acquisition stage', stage);
    }
  }, {
    key: "defaultFaucetAuthProviders",
    value: function defaultFaucetAuthProviders() {
      return [{
        id: 'twitter',
        name: 'X',
        icon: 'fa-brands fa-x-twitter'
      }, {
        id: 'github',
        name: 'GitHub',
        icon: 'fa-brands fa-github'
      }];
    }
  }, {
    key: "attachFaucetAuthStageEvents",
    value: function attachFaucetAuthStageEvents() {
      var _this3 = this;
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var root = document.getElementById('purchase-container');
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-buysaito-auth-provider]').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          var providerId = btn.getAttribute('data-buysaito-auth-provider');
          if (typeof (opt === null || opt === void 0 ? void 0 : opt.beginProviderAuth) === 'function') {
            opt.beginProviderAuth(providerId);
            return;
          }
          var faucet = _this3.app.modules.returnModule('Faucet');
          if (faucet && typeof faucet.beginProviderAuthentication === 'function') {
            faucet.beginProviderAuthentication(providerId);
          }
        };
      });
      root.querySelectorAll('[data-buysaito-stage-back]').forEach(function (back) {
        back.onclick = function (e) {
          e.preventDefault();
          _this3.exitAcquisitionStage();
        };
      });
    }

    /**
     * Restore the Stage 1 lower-section HTML captured before the Faucet
     * transition. Does not close or rebuild the overlay.
     */
  }, {
    key: "exitAcquisitionStage",
    value: function exitAcquisitionStage() {
      var _document$getElementB3;
      var stageEl = document.getElementById('buysaito-stage');
      (_document$getElementB3 = document.getElementById('purchase-container')) === null || _document$getElementB3 === void 0 || _document$getElementB3.classList.remove('buysaito-stage-faucet-auth');
      var footer = document.querySelector('#purchase-container .buysaito-footer-note');
      if (footer && this.stage1_footer_html != null) {
        footer.classList.remove('buysaito-footer-nav');
        footer.innerHTML = this.stage1_footer_html;
        this.stage1_footer_html = null;
      }
      if (!stageEl || this.stage1_html == null) {
        this.acquisition_stage = 'default';
        this.stage1_html = null;
        return;
      }
      stageEl.innerHTML = this.stage1_html;
      this.acquisition_stage = 'default';
      this.stage1_html = null;

      // Rebind Stage 1 interactions (crypto select, etc.) without re-showing overlay.
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var walletPaymentButton = document.getElementById('pay-from-wallet-btn');
      if (walletPaymentButton) {
        var reservation = this.reservation;
        walletPaymentButton.onclick = function () {
          return _this4.payFromWallet(reservation);
        };
      }

      //////////////////////
      // Select Crypto Form
      /////////////////////
      document.querySelectorAll('.purchase-crypto-item').forEach(function (el) {
        el.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var i, session, currency;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  for (i = 0; i < _this4.mod.available_currencies.length; i++) {
                    if (_this4.mod.available_currencies[i].ticker == e.currentTarget.id) {
                      _this4.crypto_selected = _this4.mod.available_currencies[i];
                    }
                  }
                  if (_this4.crypto_selected) {
                    _context3.n = 1;
                    break;
                  }
                  salert('Error reading crypto selection');
                  return _context3.a(2);
                case 1:
                  console.log(_this4.crypto_selected);
                  session = _this4.session;
                  currency = _this4.crypto_selected;
                  _context3.n = 2;
                  return _this4.checkForLocalCrypto();
                case 2:
                  if (!(!_this4.active || _this4.session !== session || _this4.crypto_selected !== currency)) {
                    _context3.n = 3;
                    break;
                  }
                  return _context3.a(2);
                case 3:
                  if (_this4.amount) {
                    _this4.showOverlay(SaitoPurchaseLoaderTemplate('Requesting Payment Instructions...'));
                    _this4.requestPaymentAddressFromServer();
                  } else {
                    _this4.render();
                  }
                case 4:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      });
      this.attachAmountEvents();

      ///////////////////
      // Deposit form
      ///////////////////
      if (document.querySelector('.buysaito-payment-box .pubkey-container')) {
        document.querySelector('.buysaito-payment-box .pubkey-container').onclick = function (e) {
          navigator.clipboard.writeText(_this4.address);
          var icon_element = document.querySelector('.buysaito-payment-box .pubkey-container i');
          icon_element.classList.toggle('fa-copy');
          icon_element.classList.toggle('fa-check');
          setTimeout(function () {
            icon_element.classList.toggle('fa-copy');
            icon_element.classList.toggle('fa-check');
          }, 800);
        };
      }
    }
  }, {
    key: "renderAmountPage",
    value: function renderAmountPage() {
      var _root$querySelector, _this$mod$available_c2, _this$mod$available_c3;
      var root = document.getElementById('buysaito-amount-form');
      if (!root) return;
      var state = this.page_amount_selection || {
        amount_input_source: 'crypto'
      };
      var sourceId = state.amount_input_source === 'saito' ? 'saito-input-amount' : 'input-amount';
      var value = ((_root$querySelector = root.querySelector("#buy-page-".concat(sourceId))) === null || _root$querySelector === void 0 ? void 0 : _root$querySelector.value) || '';
      state.crypto_selected = ((_this$mod$available_c2 = this.mod.available_currencies) === null || _this$mod$available_c2 === void 0 ? void 0 : _this$mod$available_c2.find(function (currency) {
        var _state$crypto_selecte;
        return currency.ticker === ((_state$crypto_selecte = state.crypto_selected) === null || _state$crypto_selecte === void 0 ? void 0 : _state$crypto_selecte.ticker);
      })) || ((_this$mod$available_c3 = this.mod.available_currencies) === null || _this$mod$available_c3 === void 0 ? void 0 : _this$mod$available_c3[0]);
      this.page_amount_selection = state;
      root.innerHTML = SaitoPurchaseAmountTemplate(this.app, this.mod, state, {
        inline: true
      });
      this.attachAmountEvents({
        root: root,
        state: state,
        prefix: 'buy-page-',
        inline: true
      });
      var source = root.querySelector("#buy-page-".concat(sourceId));
      source.value = value;
      source.oninput();
    }
  }, {
    key: "attachAmountEvents",
    value: function attachAmountEvents() {
      var _this5 = this;
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$root = _ref3.root,
        root = _ref3$root === void 0 ? document : _ref3$root,
        _ref3$state = _ref3.state,
        state = _ref3$state === void 0 ? this : _ref3$state,
        _ref3$prefix = _ref3.prefix,
        prefix = _ref3$prefix === void 0 ? '' : _ref3$prefix,
        _ref3$inline = _ref3.inline,
        inline = _ref3$inline === void 0 ? false : _ref3$inline;
      var get = function get(id) {
        return root === document ? document.getElementById(id) : root.querySelector("#".concat(prefix).concat(id));
      };
      var cryptoInput = get('input-amount');
      var saitoInput = get('saito-input-amount');
      var nextButton = get('next-purchase-btn');
      var currencySelect = get('payment-currency');
      if (!cryptoInput || !saitoInput || !nextButton) return;
      var updateNext = function updateNext() {
        nextButton.disabled = !state.crypto_selected || !_this5.isValidAmount(cryptoInput.value) || !_this5.isValidAmount(saitoInput.value);
      };
      var updateAmount = function updateAmount(sourceInput, targetInput, source) {
        var _state$crypto_selecte2;
        sourceInput.value = _this5.sanitizeAmountInput(sourceInput.value);
        state.amount_input_source = source;
        var ticker = (_state$crypto_selecte2 = state.crypto_selected) === null || _state$crypto_selecte2 === void 0 ? void 0 : _state$crypto_selecte2.ticker;
        var converted = ticker && sourceInput.value ? source === 'saito' ? _this5.mod.convertSaitoToOther(Number(sourceInput.value), ticker) : _this5.mod.convertToSaito(Number(sourceInput.value), ticker) : NaN;
        targetInput.value = _this5.formatAmountInput(Number(converted));
        updateNext();
      };
      cryptoInput.oninput = function () {
        return updateAmount(cryptoInput, saitoInput, 'crypto');
      };
      saitoInput.oninput = function () {
        return updateAmount(saitoInput, cryptoInput, 'saito');
      };
      if (currencySelect) {
        currencySelect.onchange = function () {
          var _this5$mod$available_;
          state.crypto_selected = (_this5$mod$available_ = _this5.mod.available_currencies) === null || _this5$mod$available_ === void 0 ? void 0 : _this5$mod$available_.find(function (currency) {
            return currency.ticker === currencySelect.value;
          });
          cryptoInput.setAttribute('aria-label', "Amount in ".concat(currencySelect.value));
          var form = currencySelect.closest('.amount-selection-box');
          form.querySelectorAll('[data-payment-logo]').forEach(function (logo) {
            logo.hidden = logo.dataset.paymentLogo !== currencySelect.value;
          });
          if (state.amount_input_source === 'saito') saitoInput.oninput();else cryptoInput.oninput();
        };
      }
      updateNext();
      nextButton.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var currency, amount, deposit, session;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!nextButton.disabled) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              currency = state.crypto_selected;
              amount = saitoInput.value;
              deposit = cryptoInput.value;
              if (!(!currency || !_this5.isValidAmount(cryptoInput.value) || !_this5.isValidAmount(saitoInput.value))) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              if (!(inline && _this5.overlay.visible)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              nextButton.disabled = true;
              if (inline) {
                _this5.reset();
                _this5.active = true;
                _this5.app.connection.emit('saito-purchase-overlay-open', function () {
                  return _this5.close();
                });
                _this5.recipient = _this5.mod.publicKey;
              }
              _this5.crypto_selected = currency;
              _this5.amount = amount;
              _this5.expected_deposit = deposit;
              _this5.showOverlay(SaitoPurchaseLoaderTemplate('Requesting Payment Instructions...'));
              session = _this5.session;
              _context4.n = 4;
              return _this5.checkForLocalCrypto();
            case 4:
              if (_this5.active && _this5.session === session && _this5.crypto_selected === currency) {
                _this5.requestPaymentAddressFromServer();
              }
              if (inline) updateNext();
            case 5:
              return _context4.a(2);
          }
        }, _callee4);
      }));
    }
  }, {
    key: "checkForLocalCrypto",
    value: function () {
      var _checkForLocalCrypto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var currency, session, _cm$options, cm, balance, _t, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              currency = this.crypto_selected;
              session = this.session;
              _context5.p = 1;
              cm = this.app.wallet.returnCryptoModuleByTicker(currency.ticker);
              if (!(cm !== null && cm !== void 0 && (_cm$options = cm.options) !== null && _cm$options !== void 0 && _cm$options.isActivated)) {
                _context5.n = 4;
                break;
              }
              _context5.n = 2;
              return cm.activate();
            case 2:
              _t = Number;
              _context5.n = 3;
              return cm.getAvailableBalance();
            case 3:
              balance = _t(_context5.v);
              if (this.session === session && this.crypto_selected === currency) {
                currency.available_balance = balance;
              }
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t2 = _context5.v;
              console.error(_t2);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 5]]);
      }));
      function checkForLocalCrypto() {
        return _checkForLocalCrypto.apply(this, arguments);
      }
      return checkForLocalCrypto;
    }()
  }, {
    key: "sanitizeAmountInput",
    value: function sanitizeAmountInput(value) {
      var maxFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
      var numericCharacters = String(value !== null && value !== void 0 ? value : '').replace(/[^0-9.]/g, '');
      if (!/[0-9]/.test(numericCharacters)) {
        return '';
      }
      var decimalIndex = numericCharacters.indexOf('.');
      if (decimalIndex === -1) {
        return numericCharacters;
      }
      var whole = numericCharacters.slice(0, decimalIndex) || '0';
      var fraction = numericCharacters.slice(decimalIndex + 1).replace(/\./g, '').slice(0, maxFractionDigits);
      return "".concat(whole, ".").concat(fraction);
    }
  }, {
    key: "formatAmountInput",
    value: function formatAmountInput(value) {
      if (!Number.isFinite(value) || value < 0) {
        return '';
      }
      return value.toLocaleString('en-US', {
        useGrouping: false,
        maximumFractionDigits: 8
      });
    }
  }, {
    key: "isValidAmount",
    value: function isValidAmount(value) {
      var amount = Number(value);
      return value !== '' && Number.isFinite(amount) && amount > 0;
    }
  }, {
    key: "canPayFromWallet",
    value: function canPayFromWallet() {
      var _this$crypto_selected;
      var balance = Number((_this$crypto_selected = this.crypto_selected) === null || _this$crypto_selected === void 0 ? void 0 : _this$crypto_selected.available_balance);
      var deposit = Number(this.expected_deposit);
      return Number.isFinite(balance) && Number.isFinite(deposit) && deposit > 0 && balance >= deposit;
    }
  }, {
    key: "payFromWallet",
    value: function () {
      var _payFromWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(reservation) {
        var success;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(!this.active || !this.overlay.visible || !reservation || this.reservation !== reservation || this.payment_detected || this.internal_payment_pending || Date.now() >= this.reserved_until || !this.canPayFromWallet())) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              // Clicking the button authorizes one transfer of the quoted deposit amount.
              this.internal_payment_pending = true;
              this.internal_payment_sending = true;
              this.ui_msg = 'Sending Payment...';
              this.render();
              _context6.n = 2;
              return this.handleInternalTransfer();
            case 2:
              success = _context6.v;
              if (!(!this.active || this.reservation !== reservation || this.payment_detected)) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2);
            case 3:
              this.internal_payment_sending = false;
              this.internal_payment_pending = success;
              this.render();
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function payFromWallet(_x3) {
        return _payFromWallet.apply(this, arguments);
      }
      return payFromWallet;
    }()
  }, {
    key: "handleInternalTransfer",
    value: function () {
      var _handleInternalTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var cm, to_address, res, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              cm = this.app.wallet.returnCryptoModuleByTicker(this.crypto_selected.ticker);
              if (!(this.address && this.mixin_id)) {
                _context7.n = 2;
                break;
              }
              to_address = this.address + '|' + this.mixin_id + '|mixin';
              _context7.n = 1;
              return cm.sendPayment(this.expected_deposit, to_address, 'success');
            case 1:
              res = _context7.v;
              return _context7.a(2, typeof res === 'string' && res.trim().length > 0);
            case 2:
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t3 = _context7.v;
              console.error(_t3);
            case 4:
              return _context7.a(2, false);
          }
        }, _callee7, this, [[0, 3]]);
      }));
      function handleInternalTransfer() {
        return _handleInternalTransfer.apply(this, arguments);
      }
      return handleInternalTransfer;
    }() //
    // reserve address -> poll pending deposit -> fetch receipts
    //
  }, {
    key: "requestPaymentAddressFromServer",
    value: function () {
      var _requestPaymentAddressFromServer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this6 = this,
          _this$mod$buysaito_pe2;
        var data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              //
              // build request payload
              //
              data = {
                initiator_pubkey: this.mod.publicKey,
                recipient_pubkey: this.recipient,
                ticker: this.crypto_selected.ticker,
                tx: this.tx
              };
              if (Number(this.amount) > 0) {
                data.issue_amount = Number(this.amount);
              }
              if (Number(this.expected_deposit) > 0) {
                data.expected_deposit = Number(this.expected_deposit);
              }
              if (!(!data.issue_amount && !data.expected_deposit)) {
                _context8.n = 1;
                break;
              }
              console.error('No valid numeric input');
              this.app.connection.emit('saito-purchase-error-notification', {
                message: 'A valid payment amount is required before requesting instructions.'
              });
              return _context8.a(2);
            case 1:
              console.log('Payment Address Request:', data);
              this.clearPaymentInstructionTimer();
              this.payment_instruction_timer = setTimeout(function () {
                if (!_this6.active || _this6.address) {
                  return;
                }
                _this6.app.connection.emit('saito-purchase-error-notification', {
                  message: 'The payment service did not return instructions. Please check your connection and try again.'
                });
              }, 35000);
              if ((_this$mod$buysaito_pe2 = this.mod.buysaito_peer) !== null && _this$mod$buysaito_pe2 !== void 0 && _this$mod$buysaito_pe2.publicKey) {
                _context8.n = 2;
                break;
              }
              this.app.connection.emit('saito-purchase-error-notification', {
                message: 'The payment service did not return instructions. Please check your connection and try again.'
              });
              return _context8.a(2);
            case 2:
              this.app.network.sendRequestAsTransaction('buysaito reserve address', data, function (response) {
                if (!(response !== null && response !== void 0 && response.address) || response.err) {
                  _this6.app.connection.emit('saito-purchase-error-notification', {
                    message: (response === null || response === void 0 ? void 0 : response.message) || (response === null || response === void 0 ? void 0 : response.err) || 'The payment service did not return instructions. Please check your connection and try again.'
                  });
                  return;
                }
                _this6.mod.pending_payments.push(response);
                _this6.receivePaymentAddressFromServer(response);
              }, this.mod.buysaito_peer.publicKey);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function requestPaymentAddressFromServer() {
        return _requestPaymentAddressFromServer.apply(this, arguments);
      }
      return requestPaymentAddressFromServer;
    }()
  }, {
    key: "receivePaymentAddressFromServer",
    value: function receivePaymentAddressFromServer(data) {
      if (!this.active || !this.crypto_selected) return;
      if (data !== null && data !== void 0 && data.ticker && data.ticker !== this.crypto_selected.ticker) return;
      this.clearPaymentInstructionTimer();
      console.log('\n/////////////////////////////////////');
      console.log('RESERVE ADDRESS RESPONSE');
      console.log(data);
      console.log('/////////////////////////////////////\n');
      if (!(data !== null && data !== void 0 && data.address) || !(data !== null && data !== void 0 && data.mixin_id) || !(data !== null && data !== void 0 && data.ticker)) {
        this.app.connection.emit('saito-purchase-error-notification', {
          message: 'The payment service returned incomplete deposit instructions.'
        });
        return;
      }

      //
      // reserve address success — extract info
      //
      if (!this.reservation || this.reservation.id !== data.id || this.reservation.address !== data.address || this.reservation.ticker !== data.ticker) {
        this.reservation = data;
        this.payment_detected = false;
        this.internal_payment_pending = false;
        this.internal_payment_sending = false;
      }
      this.address = data.address;
      this.expected_deposit = data.expected_deposit;
      this.mixin_id = data.mixin_id;
      this.reserved_until = data.reserved_until;
      if (!this.amount) {
        this.amount = data.issue_amount;
      }
      if (['pending', 'confirmed', 'issuing'].includes(data.status)) {
        this.receivePaymentDetected(data);
      } else {
        this.startReservationTimeout(this.reserved_until);
        this.render();
      }
    }
  }, {
    key: "receivePaymentDetected",
    value: function receivePaymentDetected(data) {
      var _this$crypto_selected2;
      if (!this.active || !this.reservation || (data === null || data === void 0 ? void 0 : data.id) !== this.reservation.id || data.address !== this.address || data.ticker !== ((_this$crypto_selected2 = this.crypto_selected) === null || _this$crypto_selected2 === void 0 ? void 0 : _this$crypto_selected2.ticker) || !['pending', 'confirmed', 'issuing'].includes(data.status)) {
        return;
      }
      this.payment_detected = true;
      this.clearReservationTimer();
      this.ui_msg = data.status === 'pending' ? 'Payment detected. Waiting for SAITO issuance...' : 'Payment received. Waiting for SAITO issuance...';
      this.render();
      // The issued notice can arrive after the wallet already holds the SAITO.
      // Watch the wallet so this waiting overlay does not stay open.
      this.saito_arrival_expected = this.expectedSaitoNolan();
      void this.startSaitoArrivalWatch();
    }
  }, {
    key: "clearReservationTimer",
    value: function clearReservationTimer() {
      clearTimeout(this.reservation_timer);
      this.reservation_timer = null;
    }
  }, {
    key: "expectedSaitoNolan",
    value: function expectedSaitoNolan() {
      var _this$reservation;
      var amount = Number(((_this$reservation = this.reservation) === null || _this$reservation === void 0 ? void 0 : _this$reservation.issue_amount) || this.amount || 0);
      if (!Number.isFinite(amount) || amount <= 0) {
        return 0n;
      }
      try {
        return this.app.wallet.convertSaitoToNolan(amount);
      } catch (err) {
        return 0n;
      }
    }
  }, {
    key: "startSaitoArrivalWatch",
    value: function () {
      var _startSaitoArrivalWatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this$saito_arrival_e,
          _this7 = this,
          _this$saito_arrival_t,
          _this$saito_arrival_t2;
        var expected, session, baseline, _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (!(this.saito_arrival_timer || !this.active || !this.payment_detected)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              expected = (_this$saito_arrival_e = this.saito_arrival_expected) !== null && _this$saito_arrival_e !== void 0 ? _this$saito_arrival_e : this.expectedSaitoNolan();
              if (!(expected <= 0n)) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              this.saito_arrival_expected = expected;
              session = this.session;
              baseline = 0n;
              _context9.p = 3;
              _context9.n = 4;
              return this.app.wallet.getBalance('SAITO');
            case 4:
              baseline = _context9.v;
              _context9.n = 6;
              break;
            case 5:
              _context9.p = 5;
              _t4 = _context9.v;
              console.error('BuySaito: unable to read SAITO balance for arrival watch', _t4);
              return _context9.a(2);
            case 6:
              if (!(session !== this.session || !this.active || !this.payment_detected || this.saito_arrival_timer)) {
                _context9.n = 7;
                break;
              }
              return _context9.a(2);
            case 7:
              this.saito_arrival_baseline = baseline;
              this.saito_arrival_timer = setInterval(function () {
                void _this7.checkSaitoArrival();
              }, 1500);
              (_this$saito_arrival_t = (_this$saito_arrival_t2 = this.saito_arrival_timer).unref) === null || _this$saito_arrival_t === void 0 || _this$saito_arrival_t.call(_this$saito_arrival_t2);
              void this.checkSaitoArrival();
            case 8:
              return _context9.a(2);
          }
        }, _callee9, this, [[3, 5]]);
      }));
      function startSaitoArrivalWatch() {
        return _startSaitoArrivalWatch.apply(this, arguments);
      }
      return startSaitoArrivalWatch;
    }()
  }, {
    key: "stopSaitoArrivalWatch",
    value: function stopSaitoArrivalWatch() {
      if (this.saito_arrival_timer) {
        clearInterval(this.saito_arrival_timer);
        this.saito_arrival_timer = null;
      }
      this.saito_arrival_baseline = null;
      this.saito_arrival_expected = null;
    }
  }, {
    key: "checkSaitoArrival",
    value: function () {
      var _checkSaitoArrival = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var balance, _t5;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (!(!this.active || !this.payment_detected || this.saito_issuance || this.saito_arrival_baseline == null || this.saito_arrival_expected == null)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              balance = 0n;
              _context0.p = 2;
              _context0.n = 3;
              return this.app.wallet.getBalance('SAITO');
            case 3:
              balance = _context0.v;
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t5 = _context0.v;
              return _context0.a(2);
            case 5:
              if (balance - this.saito_arrival_baseline >= this.saito_arrival_expected) {
                this.onSaitoArrived();
              }
            case 6:
              return _context0.a(2);
          }
        }, _callee0, this, [[2, 4]]);
      }));
      function checkSaitoArrival() {
        return _checkSaitoArrival.apply(this, arguments);
      }
      return checkSaitoArrival;
    }()
  }, {
    key: "onSaitoArrived",
    value: function onSaitoArrived() {
      if (!this.active || this.saito_issuance) {
        return;
      }
      this.stopSaitoArrivalWatch();
      this.close();
    }
  }, {
    key: "startReservationTimeout",
    value: function startReservationTimeout(expiryMs) {
      var _this8 = this;
      this.clearReservationTimer();
      if (this.payment_detected || !Number.isFinite(Number(expiryMs))) return;
      this.reservation_timer = setTimeout(function () {
        if (_this8.payment_detected) return;
        _this8.close();
        salert('The payment time has timed out. Please try again.');
      }, Math.max(0, Number(expiryMs) - Date.now()));
    }
  }, {
    key: "updateSaitoIssued",
    value: function updateSaitoIssued() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.overlay.visible || !this.reservation || data.id !== this.reservation.id || data.address !== this.reservation.address || data.ticker !== this.reservation.ticker || !data.paid) {
        return;
      }
      this.stopSaitoArrivalWatch();
      this.active = false;
      clearTimeout(this.timer);
      this.clearReservationTimer();
      this.clearPaymentInstructionTimer();
      this.saito_issuance = data;
      this.renderSaitoCompletion();
    }
  }, {
    key: "receiveSaitoPayment",
    value: function receiveSaitoPayment(data) {
      var _this$mod$buysaito_pe3, _this$mod$buysaito_pe4, _this$saito_issuance;
      if (!this.overlay.visible || !this.reservation || (data === null || data === void 0 ? void 0 : data.ticker) !== 'SAITO' || data.receiver !== this.mod.publicKey || !Number.isFinite(Number(data.amount)) || Number(data.amount) <= 0) {
        return;
      }
      var peer = (_this$mod$buysaito_pe3 = this.mod.buysaito_peer) === null || _this$mod$buysaito_pe3 === void 0 ? void 0 : _this$mod$buysaito_pe3.publicKey;
      if (peer && data.sender && data.sender !== peer) {
        return;
      }

      // While waiting for issuance, wallet arrival is enough to dismiss the overlay.
      if (this.active && this.payment_detected && !this.saito_issuance) {
        try {
          var _this$saito_arrival_e2;
          var expected = (_this$saito_arrival_e2 = this.saito_arrival_expected) !== null && _this$saito_arrival_e2 !== void 0 ? _this$saito_arrival_e2 : this.expectedSaitoNolan();
          var received = this.app.wallet.convertSaitoToNolan(data.amount);
          if (expected > 0n && received >= expected) {
            this.onSaitoArrived();
            return;
          }
        } catch (err) {
          // Fall through to the signature receipt path below.
        }
      }
      if (data.sender !== ((_this$mod$buysaito_pe4 = this.mod.buysaito_peer) === null || _this$mod$buysaito_pe4 === void 0 ? void 0 : _this$mod$buysaito_pe4.publicKey) || !data.signature) {
        return;
      }
      // The browser can receive the payout block before the treasury's relay notice.
      // Retain receipts for this purchase session and match its exact payout signature.
      if (this.saito_receipts.has(data.signature)) return;
      this.saito_receipts.set(data.signature, data.amount);
      if (((_this$saito_issuance = this.saito_issuance) === null || _this$saito_issuance === void 0 ? void 0 : _this$saito_issuance.paid) === data.signature) {
        this.renderSaitoCompletion();
      }
    }
  }, {
    key: "renderSaitoCompletion",
    value: function renderSaitoCompletion() {
      if (!this.overlay.visible || !this.saito_issuance) return;
      this.showOverlay(SaitoPurchaseCompleteTemplate(this.app, _objectSpread(_objectSpread({}, this.saito_issuance), {}, {
        received_amount: this.saito_receipts.get(this.saito_issuance.paid)
      })));
    }
  }, {
    key: "showOverlay",
    value: function showOverlay(html) {
      var _this9 = this;
      this.overlay.closebox = true;
      this.overlay.show(html, function () {
        _this9.active = false;
        _this9.reset();
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.active = false;
      this.reset();
      this.overlay.close();
    }
  }, {
    key: "clearPaymentInstructionTimer",
    value: function clearPaymentInstructionTimer() {
      if (this.payment_instruction_timer) {
        clearTimeout(this.payment_instruction_timer);
        this.payment_instruction_timer = null;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      console.log('Reset Saito-Purchase Values');
      this.session++;
      this.mod.pending_payments = [];

      //
      // reset values (incase we want to reuse the overlay)
      //
      this.amount = 0;
      this.internal_transfer = null;
      this.expected_deposit = 0;
      this.amount_input_source = 'crypto';
      this.reserved_until = 0;
      this.crypto_selected = false;
      this.tx = null;
      this.recipient = '';
      this.address = '';
      this.description = '';
      this.payment_detected = false;
      this.internal_payment_pending = false;
      this.internal_payment_sending = false;
      this.reservation = null;
      this.saito_issuance = null;
      this.saito_receipts.clear();
      this.acquisition_stage = 'default';
      this.acquisition_options = [];
      this.stage1_html = null;
      this.stage1_footer_html = null;
      this.faucet_already_issued = null;
      clearTimeout(this.timer);
      this.timer = null;
      this.clearPaymentInstructionTimer();
      this.stopSaitoArrivalWatch();
      this.clearReservationTimer();
    }
  }]);
}();
module.exports = SaitoPurchaseOverlay;